<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'MOBILE_USERS', url: '/admin/mobile-users' },
    { label: 'UPDATE_MOBILE_USER' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_MOBILE_USER"></page-header>

<card>
  <div class="is-flex">
    <form
      autocomplete="off"
      action=""
      class="form"
      (submit)="onSubmit($event)"
      style="width: 400px"
    >
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="USERNAME">{{
          'USERNAME' | translate
        }}</label>
        <div class="control">
          <input
            class="input is-small"
            name="username"
            type="text"
            (input)="handleFieldChange($event)"
            placeholder="e.g alex_smith"
            [value]="getField(['username'])"
            [ngClass]="{ 'is-danger': hasError('username') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('username')">
          {{ getError('username') }}
        </p>
      </div>
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="FIRST_NAME">{{
          'FIRST_NAME' | translate
        }}</label>
        <div class="control">
          <input
            class="input is-small"
            name="firstName"
            type="text"
            (input)="handleFieldChange($event)"
            placeholder="e.g Alex"
            [value]="getField(['firstName'])"
            [ngClass]="{ 'is-danger': hasError('firstName') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('firstName')">
          {{ getError('firstName') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="LAST_NAME">{{
          'LAST_NAME' | translate
        }}</label>
        <div class="control">
          <input
            class="input is-small"
            name="lastName"
            type="text"
            (input)="handleFieldChange($event)"
            placeholder="e.g Smith"
            [value]="getField(['lastName'])"
            [ngClass]="{ 'is-danger': hasError('lastName') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('lastName')">
          {{ getError('lastName') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="MODE">{{
          'MODE' | translate
        }}</label>
        <div class="control">
          <ng-select
            [translationEditableModalDirective]="mobileUserModeKeys"
            [translationEditableModalDirectiveDefaults]="mobileUserModeDefaults"
            [items]="mobileUserModes"
            [multiple]="false"
            [closeOnSelect]="true"
            (change)="handleFieldChange($event?.name, 'mode')"
            [ngClass]="{ 'is-danger': hasError('mode') }"
            [ngModel]="getField(['mode'])"
            [ngModelOptions]="{ standalone: true }"
            bindLabel="title"
            bindValue="name"
            class="is-small"
          >
          </ng-select>
        </div>
        <p class="help is-danger" *ngIf="hasError('mode')">
          {{ getError('mode') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label
          class="label"
          translationEditableDirective="RESPONSIBILITY_ZONES"
          >{{ 'RESPONSIBILITY_ZONES' | translate }}</label
        >
        <div class="control">
          <ng-select
            [items]="layerFeatures"
            [multiple]="true"
            [closeOnSelect]="false"
            (change)="handleFieldChange($event, 'layerFeatures')"
            [ngClass]="{ 'is-danger': hasError('layerFeatures') }"
            [ngModel]="getField(['layerFeatures']) | array"
            [ngModelOptions]="{ standalone: true }"
            bindLabel="label"
            [typeahead]="onZonesAutocomplete$"
            class="is-small"
          >
          </ng-select>
        </div>
        <p class="help is-danger" *ngIf="hasError('layerFeatures')">
          {{ getError('layerFeatures') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="ACTIVATION_CODE">{{
          'ACTIVATION_CODE' | translate
        }}</label>
        <div class="control" style="font-size: 20px; font-weight: bold">
          <span *ngIf="getField(['activation'])">{{
            getField(['activation', 'activationCode'])
          }}</span>

          <i
            *ngIf="getField(['activation'])"
            (click)="
              copyToClipboard(getField(['activation', 'activationCode']))
            "
            class="fa-regular fa-copy"
            style="
              cursor: pointer;
              font-size: 17px;
              transform: translate(10px, -10px);
            "
          ></i>

          <span
            style="color: green"
            *ngIf="!getField(['activation'])"
            translationEditableDirective="ACTIVATED"
            >{{ 'ACTIVATED' | translate }}</span
          >

          <alert #reissueAlert (confirm)="reissueCode()" titleTrnKey="ARE_YOU_SURE" textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS" confirmButtonTextTrnKey="YES" />
          <button
            class="button is-secondary is-small ml-4"
            *ngIf="!getField(['activation'])"
            [disabled]="codeIssueLoading"
            (click)="reissueAlert.fire()"
            translationEditableDirective="REISSUE_ACTIVATION_CODE"
          >
            {{ 'REISSUE_ACTIVATION_CODE' | translate }}
          </button>
        </div>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="ACCOUNT_STATUS">{{
          'ACCOUNT_STATUS' | translate
        }}</label>
        <div class="control">
          <chip
            [checked]="getField(['suspended'])"
            (onChange)="checkboxChange($event, 'suspended')"
            [value]="!getField(['suspended'])"
          >
            <span
              [translationEditableDirective]="
                (getField(['suspended']) ? 'SUSPENDED' : 'ACTIVE') | translate
              "
            >
              {{
                (getField(['suspended']) ? 'SUSPENDED' : 'ACTIVE') | translate
              }}
            </span>
          </chip>
        </div>
      </div>
    </form>
    <div class="is-flex-grow-1 pl-6">
      <label
        class="label"
        translationEditableDirective="RESPONSIBILITY_ZONES"
        >{{ 'RESPONSIBILITY_ZONES' | translate }}</label
      >
      <active-layer-map
        [selectedZones]="getField(['layerFeatures']) | array"
        (onSelectionChange)="handleFieldChange($event, 'layerFeatures')"
      ></active-layer-map>
    </div>
  </div>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/mobile-users']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
